module.exports = __webpack_public_path__ + "static/media/adrift.1ba2caa6.mp3";